<template>
  <ais-state-results class="py-lg-4 py-2">
    <template v-slot="{ state: { query, hierarchicalFacetsRefinements }, results: { nbHits } }">
      <div class="fs-4">
        <strong>{{ nbHits }} results</strong>
        <template v-if="query">
          for <strong>"{{ query }}"</strong>
        </template>
        <span v-show="hierarchicalFacetsRefinements['super_category'] && hierarchicalFacetsRefinements['super_category'].length > 0">
          under <strong>{{ hierarchicalFacetsRefinements['super_category'][0] }}</strong>
        </span>
        in <a href="#" class="primary-link" data-bs-toggle="modal" data-bs-target="#mapLocationModal"><span class="bi bi-geo-alt-fill"></span> {{ currentLocationText }}</a>
        <div v-show="nbHits === 0">
          <br />
          <p class="fs-5">Please try searching for a different keyword or removing some filters</p>
          <SearchFilterClear />
        </div>
      </div>
    </template>
  </ais-state-results>
</template>

<script>
import { AisStateResults } from 'vue-instantsearch/vue3/es';
import SearchFilterClear from './search_filter_clear.vue';
import LocationMixin from '../../mixins/location_mixin.js';

export default {
  name: 'SearchResultCount',
  components: {
    SearchFilterClear,
    AisStateResults,
  },
  mixins: [LocationMixin],
};
</script>
